import {
  DOWNLOAD_EMPLOYEE_DOCUMENTS,
  EMPLOYEE_DOCUMENT_STAGES_ALIAS,
  UPDATE_EMPLOYEE_DOCUMENTS,
} from '../../../constants';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DownloadIcon from '@mui/icons-material/Download';
import { useArtifactDownloadHelper } from 'domain/shared/artifact';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import { DEFAULT_ERROR_MESSAGE } from 'framework/form';
import EditEmployeeDocumentAction from './EditEmployeeDocumentAction';
import AnnulEmployeeDocumentAction from './AnnulEmployeeDocumentAction';
import { useShowContext } from 'framework/show';
import { DocumentStorageItemType } from 'framework/documentStorage';
import { DropdownMenuActions } from 'framework/ui/menu';

const EmployeeDocumentViewActions = () => {
  const { addMessage } = useMessageService();
  const { downloadDocumentStorage } = useArtifactDownloadHelper();
  const { data, setData } = useShowContext<DocumentStorageItemType>();

  const documentData = data.getData();

  const handleDownload = async (filePath: string) => {
    try {
      await downloadDocumentStorage(filePath);
    } catch {
      addMessage(new ErrorMessage(DEFAULT_ERROR_MESSAGE));
    }
  };

  return (
    <DropdownMenuActions
      actions={[
        {
          permission: UPDATE_EMPLOYEE_DOCUMENTS,
          isVisible: (entityData: DocumentStorageItemType) =>
            entityData?.metadata?.stage !== EMPLOYEE_DOCUMENT_STAGES_ALIAS.ANNULLED,
          form: {
            Component: EditEmployeeDocumentAction,
            title: 'Edit document',
            afterSubmit: {
              execute: updatedEnity => {
                setData!({
                  ...documentData,
                  metadata: {
                    ...documentData.metadata,
                    section: updatedEnity.section,
                    fileType: updatedEnity.fileType,
                    stage: updatedEnity.stage,
                    office: updatedEnity.office,
                    number: updatedEnity.number,
                    category: updatedEnity.category,
                  },
                });
              },
            },
          },
          icon: <EditIcon />,
          title: 'Edit',
        },
        {
          permission: DOWNLOAD_EMPLOYEE_DOCUMENTS,
          onClick: entityData => {
            handleDownload(entityData?.path);
          },
          icon: <DownloadIcon />,
          title: 'Download',
        },
        {
          permission: UPDATE_EMPLOYEE_DOCUMENTS,
          isVisible: (entityData: DocumentStorageItemType) =>
            entityData?.metadata?.stage !== EMPLOYEE_DOCUMENT_STAGES_ALIAS.ANNULLED,
          form: {
            Component: AnnulEmployeeDocumentAction,
            title: 'Are you sure?',
            afterSubmit: {
              execute: updatedEnity => {
                setData!({
                  ...documentData,
                  metadata: {
                    ...documentData.metadata,
                    annullingReason: updatedEnity.annullingReason,
                    stage: EMPLOYEE_DOCUMENT_STAGES_ALIAS.ANNULLED,
                  },
                });
              },
            },
          },
          icon: <DeleteIcon />,
          title: 'Annul',
        },
      ]}
    />
  );
};

export default EmployeeDocumentViewActions;
